import { QueryOptions, useQuery } from 'react-query';
import { getSubAccountSettings } from '../';
import { GetSubAccountSettingsResponse } from '@weave/schema-gen-ts/dist/schemas/payments-platform/justifi-integration/justifi_integration.pb';

export const useGetSubAccountSettings = (
  locationId: string | undefined,
  options: QueryOptions<GetSubAccountSettingsResponse> = {}
) => {
  const isQueryEnabled = 'enabled' in options ? !!options.enabled : true;

  const { data, ...queryResult } = useQuery(
    [locationId, 'justifi-sub-account-settings'],
    () => getSubAccountSettings({ locationId: locationId! }),
    { ...options, enabled: !!locationId && isQueryEnabled }
  );

  return { ...data, data, ...queryResult };
};
